import { translate } from "app/filters/i18nFilter";
import { columnKeys } from "app/pages/sales-intelligence/utils/i18n/columns";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";
import { similarwebValueType } from "app/pages/sales-intelligence/common-components/export-table/valueType";

const PARENT_COMPANY_FIELD = "parent_company";
const SUBSIDIARY_COMPANIES_FIELD = "subsidiary_companies";
const PARENT_COMPANY_DOMAIN_FIELD = "parent_company_domain";
const SUBSIDIARY_DOMAINS_FIELD = "subsidiary_domains";

export const getSubsidiaryFieldsConfig = (): SimilarwebFieldsConfig => {
    const config: SimilarwebFieldsConfig = {
        [PARENT_COMPANY_FIELD]: {
            name: translate(columnKeys.title("parent_company")),
            example: "ACME Holdings",
            field: "parent_company",
            valueType: similarwebValueType.Text,
        },
        [SUBSIDIARY_COMPANIES_FIELD]: {
            name: translate(columnKeys.title("subsidiary_companies")),
            example: "ACME Technologies Limited, ACME labs EMEA",
            field: "subsidiary_companies",
            valueType: similarwebValueType.List,
        },
        [PARENT_COMPANY_DOMAIN_FIELD]: {
            name: translate(columnKeys.title("parent_company_domain")),
            example: "acme-holdings.com",
            field: "parent_company_domain",
            valueType: similarwebValueType.Text,
        },
        [SUBSIDIARY_DOMAINS_FIELD]: {
            name: translate(columnKeys.title("subsidiary_domains")),
            example: "acme-technologies.com, acme-labs-emea.com",
            field: "subsidiary_domains",
            valueType: similarwebValueType.List,
        },
    };

    return Object.seal(config);
};

export const getSubsidiaryFieldsKeys = () => Object.keys(getSubsidiaryFieldsConfig());
